import { render } from "./NotUsableChoicesDrawer.vue?vue&type=template&id=15f5bd49&scoped=true"
import script from "./NotUsableChoicesDrawer.vue?vue&type=script&lang=js"
export * from "./NotUsableChoicesDrawer.vue?vue&type=script&lang=js"

import "./NotUsableChoicesDrawer.vue?vue&type=style&index=0&id=15f5bd49&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f5bd49"]])

export default __exports__
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QScrollArea,QCheckbox});
